import {
  Box,
  Flex,
  Grid,
  GridItem,
  Text,
  IconButton,
  Divider,
  Link,
  VStack,
} from "@chakra-ui/react";
import { FaInstagram, FaEnvelope, FaFacebook, FaYoutube } from "react-icons/fa";

export default function Footer() {
  return (
    <Box bg="#0F0825" color="white" pt={8} pb={8} px={16}>
      <Grid
       
        mx="auto"
        px={6}
        templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
        gap={12}
      >
        {/* Column 1 */}
        <GridItem>
          <Text color="#BDA8FB" fontWeight="bold" mb={4}>
            Games
          </Text>
         <Grid templateColumns="repeat(2, max-content)" gap={3}>
  <Link href="/games/ludo" _hover={{ color: "#BDA8FB" }}>Ludo</Link>
  <Link href="/games/pool" _hover={{ color: "#BDA8FB" }}>Pool</Link>
  <Link href="/games/rummy" _hover={{ color: "#BDA8FB" }}>Rummy</Link>
  <Link href="/games/poker" _hover={{ color: "#BDA8FB" }}>Poker</Link>
  <Link href="/games/fantasy" _hover={{ color: "#BDA8FB" }}>Fantasy</Link>
  <Link href="/games/cricket" _hover={{ color: "#BDA8FB" }}>Cricket</Link>
</Grid>
        </GridItem>

        {/* Column 2 */}
        <GridItem>
          <Text color="#BDA8FB" fontWeight="bold" mb={4}>
            Resources
          </Text>
          <VStack align="start" spacing={2}>
            {/* <Link href="/blog" _hover={{ color: "#BDA8FB" }}>Blog</Link> */}
            <Link href="/privacy-policy" _hover={{ color: "#BDA8FB" }}>Privacy Policy</Link>
            <Link href="/terms-and-conditions" _hover={{ color: "#BDA8FB" }}>Terms of Service</Link>
          </VStack>
        </GridItem>

        {/* Column 3 */}
        <GridItem>
          <Text color="#BDA8FB" fontWeight="bold" mb={4}>
            Connect
          </Text>

          <Flex gap={4}>
            <IconButton
              as={Link}
              href="https://www.instagram.com/winnsta_official?utm_source=qr&igsh=dmtkY2ZkOGc2OGNo"
              isExternal
              aria-label="Instagram"
              icon={<FaInstagram />}
              variant="outline"
              color="white"
              borderColor="#6B46C1"
              _hover={{ bg: "#6B46C1", transform: "scale(1.1)" }}
              borderRadius="full"
            />
            <IconButton
              as={Link}
              href="https://www.facebook.com/winnsta.official"
              isExternal
              aria-label="Facebook"
              icon={<FaFacebook />}
              variant="outline"
              color="white"
              borderColor="#6B46C1"
              _hover={{ bg: "#6B46C1", transform: "scale(1.1)" }}
              borderRadius="full"
            />
            <IconButton
              as={Link}
              href="https://www.youtube.com/@WinnstaApp"
              isExternal
              aria-label="YouTube"
              icon={<FaYoutube />}
              variant="outline"
              color="white"
              borderColor="#6B46C1"
              _hover={{ bg: "#6B46C1", transform: "scale(1.1)" }}
              borderRadius="full"
            />
            <IconButton
              as={Link}
              href="mailto:support@winnsta.com"
              aria-label="Email"
              icon={<FaEnvelope />}
              variant="outline"
              color="white"
              borderColor="#6B46C1"
              _hover={{ bg: "#6B46C1", transform: "scale(1.1)" }}
              borderRadius="full"
            />
          </Flex>
        </GridItem>
      </Grid>

      <Divider my={10} borderColor="whiteAlpha.300" />

      {/* Bottom text */}
     <Text textAlign="center" fontSize="sm" opacity={0.6}>
  © {new Date().getFullYear()} Winnsta Game. All Rights Reserved.
</Text>

      <Text textAlign="center" fontSize="xs" opacity={0.4} mt={2}>
        This is an official site. Winnsta is a registered trademark of its respective owners.
      </Text>
    </Box>
  );
}
